import { render, staticRenderFns } from "./CaseOrderTable.vue?vue&type=template&id=362baeea&scoped=true&"
import script from "./CaseOrderTable.vue?vue&type=script&lang=js&"
export * from "./CaseOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./CaseOrderTable.vue?vue&type=style&index=0&id=362baeea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362baeea",
  null
  
)

export default component.exports